import gql from 'graphql-tag';

import {
	LastEditedVersionFragment,
	LastEditedDraftVersionFragment,
} from './LastEditedVersionFragments.fragment.ts';

export const ContentTypesHeaderQuery = gql`
	query ContentTypesHeaderQuery($contentId: ID, $useObjectHeader: Boolean!) {
		content(id: $contentId, status: ["archived", "current", "draft"]) {
			nodes {
				id
				title
				operations {
					operation
					targetType
				}
				space {
					id
					name
					key
					alias
				}
				type
				subType
				status
				version @include(if: $useObjectHeader) {
					contentTypeModified
					number
					friendlyWhen
					...LastEditedVersionFragment
				}
				draftVersion @include(if: $useObjectHeader) {
					contentTypeModified
					number
					friendlyWhen
					...LastEditedDraftVersionFragment
				}
			}
		}
	}

	${LastEditedVersionFragment}
	${LastEditedDraftVersionFragment}
`;
